<template>
  <div class="">
    <div class="is-pulled-left">
      <p class="chart-title">
        <slot name="logo" />
        {{ title }}
        <slot name="tooltip" />
      </p>
    </div>
    <div class="is-pulled-right has-text-right">
      <div class="total-block">
        <p v-if="totalFormat == 'currency'" class="total has-text-weight-bold">
          {{ total | currencyFormat }}
        </p>
        <p v-else class="total has-text-weight-bold">
          {{ total | numberFormat(totalFormat) }}
        </p>
        <div v-if="prevTotal" class="increase-rate" :class="increaseRateUpOrDown">
          <span v-if="increaseUp">+</span>
          <span>{{ increaseRate | numberFormat("0.0%") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "total", "prevTotal", "totalFormat"],
  computed: {
    increaseRate() {
      if (!this.prevTotal) return 0;
      return this.prevTotal ? (this.total - this.prevTotal) / this.prevTotal : 0;
    },
    increaseUp() {
      return this.increaseRate >= 0;
    },
    increaseRateUpOrDown() {
      return this.increaseRate >= 0 ? "plus" : "minus";
    },
  },
};
</script>

<style scoped lang="scss">
.chart-title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: "Noto Sans", sans-serif;
}

.total-block {
  display: block;
  font-family: "Roboto", sans-serif;

  .total {
    font-size: 44px;
    line-height: 50px;
  }
}

.increase-rate {
  font-weight: 500;

  span {
    font-size: 14px;
  }
}

.increase-rate.plus {
  color: $primary;
}

.increase-rate.minus {
  color: #e23e57;
}
</style>
